import Vue from 'vue'
import Router from 'vue-router'
import RootAdminRoutes from './routes/root-admin'
import EventRoutes from './routes/event'
import AuthRoutes from './routes/auth'
import GuestRoutes from './routes/guest'
import UserRoutes from './routes/user'
import CalendarRoutes from './routes/calendar'
import InventoryRoutes from './routes/inventory'
import {
    guardInRole,
    guardHavePermission,
    guardRoleLevel
} from './guards/index'

import Settings from '@/components/Settings/Settings'

import AddBanner from '@/components/Banners/AddBanner'
import AddTable from '@/components/Tables/AddTable'
import AddEquipment from '@/components/Equipment/AddEquipment'
import AddHall from '@/components/Halls/AddHall'
import EditEquipment from '@/components/Equipment/EditEquipment'
import EditBanner from '@/components/Banners/EditBanner'

import EditTable from '@/components/Tables/EditTable'

import NotFound from '@/components/NotFound'

//import Calendar from '@/components/Calendar/Calendar'

import AddPreset from '@/components/Presets/AddPreset'

import EventPreset from '@/components/Presets/EventPreset'
import TablesStatus from '@/components/Tables/TablesStatus'


import Seating from '@/components/Guests/Seating'
import SMS from '@/components/SMS/SMS'


import EventBuilderPage from '@/pages/EventBuilderPage'


const QuotationForm = () => import('@/components/Quote/QuoteForm')
const DrinksAssign = () => import('@/components/Drinks/DrinksAssign')


// meeting
const MeetingForm = () => import('@/components/Meeting/MeetingForm')
const MeetingView = () => import('@/components/Meeting/ViewMeeting')

//Kiosk

import KioskTablesPreset from '@/components/Kiosk/KioskTablesPreset'

//pages

const BrowsePage = () => import('@/pages/BrowsePage')

const SignContractPage = () => import('@/pages/SignContractPage')

const AnalyticsPage = () => import('@/pages/AnalyticsPage')

import store from '../store'
import vuexI18n from 'vuex-i18n';
import { releaseScrollLocks, installScrollLockGuard } from '../modules/ScrollLockGuard'
import { homeRouteFor, isHostingStationUser } from '../core/acl/venue'

//import languages
import TPL_HE from '../translations/he'
import TPL_EN from '../translations/en'
import TPL_RU from '../translations/ru'
import { ROLES_NUM as Role } from '../core/auth/roles.enum'
import { isPlanup, getPageTitle } from '../Config'

// Helper to check for auth token cookie
const getTokenCookie = () => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; token=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('he', TPL_HE);
Vue.i18n.add('en', TPL_EN);
Vue.i18n.add('ru', TPL_RU);
Vue.i18n.set(store.state.preferences.lang);

Vue.use(Router)
//const Role = Roles;



import io from 'socket.io-client'
import Config from '../Config'


const router = new Router({

    mode: 'history',
    routes: [


        {
            path: '/accessibility',
            name: 'Accessibility',
            component: () => import('@/components/Accessibility/Accessibility.vue'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },

        {
            path: '/terms',
            name: 'Terms',
            component: () => import('@/components/Terms/Terms.vue'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },

        {
            path: '/privacy',
            name: 'Privacy',
            component: () => import('@/components/Privacy/Privacy.vue'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },

        {
            path: '/blog',
            name: 'Blog',
            component: () => import('@/pages/BlogPage'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },
        {
            path: '/blog/:slug',
            name: 'BlogPost',
            component: () => import('@/pages/BlogPostPage'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },

        {
            path: '/reports/eventReport',
            name: 'EventsReports',
            component: () => import('@/components/Reports/EventsReport.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/eventReportFilter',
            name: 'EventsReportsFilter',
            component: () => import('@/components/Reports/EventsReportFilter.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/taxDocumentReport',
            name: 'taxDocumentReport',
            component: () => import('@/components/Reports/TaxDocumentReport.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/taxDocumentReportFilter',
            name: 'taxDocumentReportFilter',
            component: () => import('@/components/Reports/TaxDocumentReportFilter.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/aggregationReport',
            name: 'AggregationReport',
            component: () => import('@/components/Reports/AggregationReport.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/aggregationReportFilter',
            name: 'AggregationReportFilter',
            component: () => import('@/components/Reports/AggregationReportFilter.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/reports/pivot',
            name: 'PivotBuilder',
            component: () => import('@/components/Reports/PivotBuilder.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            path: '/reports/pnl',
            name: 'PnlReport',
            component: () => import('@/components/Reports/PnlReport.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            // דוח תזרים: expected payments, checks, income and expenses by month
            path: '/reports/cashflow',
            name: 'CashflowReport',
            component: () => import('@/components/Reports/CashflowReport.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            path: '/reports',
            name: 'Reports',
            component: () => import('@/components/Reports/ReportsPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            path: '/expenses',
            name: 'Expenses',
            component: () => import('@/components/Expenses/ExpensesPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'expenses.view'
            }
        },
        {
            path: '/pdf/:id',
            name: 'PDFView',
            component: () => import('@/components/Documents/Pdf.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/document/',
            name: 'EditDocumentPage',
            component: () => import('@/components/Documents/EditDocumentPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            path: '/automations/',
            name: 'Automations',
            component: () => import('@/components/Automations/Automations'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            path: '/editAutomation/:id?',
            name: 'EditAutomation',
            component: () => import('@/components/Automations/EditAutomation'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            path: '/customer/',
            name: 'NewCustomerPage',
            component: () => import('@/components/Customers/NewCustomerPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            path: '/',
            name: 'landing',
            component: () => import('@/pages/LandingPage'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },
        {
            path: '/signup',
            name: 'signup',
            component: () => import('@/pages/SignupPage'),
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },

        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/pages/DashboardPage'),
            meta: {
                requiresAuth: true,
                // userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/tasks',
            name: 'tasks',
            component: () => import('@/components/Tasks/TasksPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            // מעקב פגישות: the meetings by their סטטוס - cancelled / no-shows, the ones to set again
            path: '/meetings',
            name: 'meetingsTracking',
            component: () => import('@/components/Meeting/MeetingsTrackingPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },


        {
            path: '/taxDocument/:id',
            name: 'taxDocument',
            component: () => import('@/components/Accounting/TaxDocument'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },

        {
            path: '/eventToCustomer/:id',
            name: 'eventToCustomer',
            component: () => import('@/components/Customers/EventToCustomer'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },

        {
            path: '/meetingToCustomer/:id',
            name: 'meetingToCustomer',
            component: () => import('@/components/Customers/MeetingToCustomer'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },

        {
            path: '/contactToCustomer/:id',
            name: 'contactToCustomer',
            component: () => import('@/components/Customers/ContactToCustomer'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },


        {
            path: '/createTaxDocument',
            name: 'createTaxDocument',
            component: () => import('@/components/Accounting/CreateTaxDocument'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },


        {
            path: '/accounting',
            name: 'accounting',
            component: () => import('@/components/Accounting/AccountingPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            // תשלומים צפויים: the payment schedules of every deal, by due date
            path: '/expected-payments',
            name: 'expectedPayments',
            component: () => import('@/components/Accounting/ExpectedPaymentsPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },
        {
            // שעון נוכחות: the employee's punches, the manager's report and corrections (time-clock module)
            path: '/time-clock',
            name: 'timeClock',
            component: () => import('@/components/TimeClock/TimeClockPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            // צ'קים: status, deposits, bounced checks
            path: '/checks',
            name: 'checks',
            component: () => import('@/components/Accounting/ChecksPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'reports.view'
            }
        },

        {
            path: '/milestones',
            name: 'milestones',
            component: () => import('@/components/Milestones/MilestonesPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },


        {
            path: '/log',
            name: 'LogsPage',
            component: () => import('@/components/Log/LogPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }

        },

        {
            path: '/customers',
            name: 'customers',
            component: () => import('@/components/Customers/Customers2'),
            meta: {
                requiresAuth: true,
                // userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },
        {
            // archive of deleted customers — same table component in archive mode
            path: '/customers-archive',
            name: 'customersArchive',
            component: () => import('@/components/Customers/Customers2'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        {
            // old customers table, kept reachable as a fallback while Customers2 beds in
            path: '/customers2',
            name: 'customers2',
            component: () => import('@/components/Customers/Customers'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        // מצב תצוגה ללקוח: the customer's event as a full-screen presentation the customer looks at (no money, no
        // CRM) - opened from the strip of the customer page, or straight by its URL on a second screen
        {
            path: '/customer/:id/present',
            name: 'CustomerPresentation',
            component: () => import('@/components/Customers/CustomerPresentation'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/customer/:id',
            name: 'CustomerPage',
            component: () => import('@/components/Customers/CustomerPage'),
            meta: {
                requiresAuth: true,
                matchHeight: true
            }
        },
        // {
        //     path: '/customer/',
        //     name: 'NewCustomerPage',
        //     component: () => import('@/components/Customers/NewCustomerPage'),
        //     meta: {
        //         requiresAuth: true,
        //         matchHeight: true
        //     }
        // },
        {
            path: '/event/tables/preset',
            name: 'KioskTablesPreset',
            component: KioskTablesPreset,
            meta: {
                requiresAuth: true,
                minimumUserLevel: 3,
                matchHeight: true
            }
        },

        ...RootAdminRoutes,
        ...EventRoutes,
        ...AuthRoutes,
        ...GuestRoutes,
        ...UserRoutes,
        ...CalendarRoutes,
        ...InventoryRoutes,


        {
            path: '/notFound',
            name: 'notFound',
            component: NotFound,
            meta: {
                requiresAuth: false,
                matchHeight: true
            }
        },
        // {
        //     path: '/settings/templates',
        //     name: 'settings.templates',
        //     component: () => import('@/components/Settings/Tabs/TemplatesTab'),
        //     meta: {
        //         requiresAuth: true,
        //         userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
        //         matchHeight: true
        //     }
        // },
        {
            path: '/settings/banners/add',
            name: 'addBanner',
            component: AddBanner,
            meta: {
                requiresAuth: true,
                minimumUserLevel: 1,
                matchHeight: true
            }
        },

        {
            path: '/settings/presets/add',
            name: 'addPreset',
            component: AddPreset,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/presets/:id',
            name: 'editPreset',
            component: () => import('@/components/Presets/EditPreset'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/preset/:id',
            name: 'eventPreset',
            component: EventPreset,
            meta: {
                requiresAuth: true,
                //userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                havePermission: 'event.update',
                matchHeight: true
            }
        },

        {
            path: '/settings/halls/add',
            name: 'addHall',
            component: AddHall,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/tables/add',
            name: 'addTable',
            component: AddTable,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/equipment/add',
            name: 'addEquipment',
            component: AddEquipment,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/banners/:id',
            name: 'editBanner',
            component: EditBanner,
            meta: {
                requiresAuth: true,
                minimumUserLevel: 1,
                matchHeight: true
            }
        },

        {
            path: '/settings/equipment/:id',
            name: 'editEquipment',
            component: EditEquipment,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/tables/:id',
            name: 'editTable',
            component: EditTable,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },

        {
            path: '/settings/halls/:id',
            name: 'editHall',
            component: () => import('@/components/Halls/EditHall'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true
            }
        },





        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },


        {
            // הגדרות ← איחוד לקוחות כפולים
            path: '/settings/duplicates',
            name: 'duplicateCustomers',
            component: () => import('@/components/Settings/DuplicateCustomers.vue'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            path: '/settings/homepage',
            name: 'settingsHomepage',
            component: () => import('@/components/Settings/HomepageSettings.vue'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },

        // Must stay above the '/settings/:tab' catch-all.
        {
            path: '/settings/booking',
            name: 'settingsBooking',
            component: () => import('@/components/Settings/BookingSettings.vue'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler, Role.HallManager],
                matchHeight: true,
                havePermission: 'settings.view',
                requireService: 10
            }
        },

        {
            // עמדת אירוח — the reception desk: pick the couple, then the check-in screens.
            // guests.arrival is held by the owner, the staff and (as its only key) the desk login.
            path: '/hosting-station',
            name: 'hostingStation',
            component: () => import('@/components/HostingStation/HostingStationHome.vue'),
            meta: {
                requiresAuth: true,
                havePermission: 'guests.arrival',
                requireService: 11
            }
        },
        {
            path: '/hosting-station/:eventId',
            name: 'hostingStationEvent',
            component: () => import('@/components/HostingStation/HostingStationEvent.vue'),
            meta: {
                requiresAuth: true,
                havePermission: 'guests.arrival',
                requireService: 11
            }
        },
        {
            // the venue suite's settings: floor plans, sketches, the RSVP finalize deadline
            path: '/settings/venue',
            name: 'venueSettings',
            component: () => import('@/components/Settings/VenueSettings.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view',
                requireService: [11, 12, 13, 14, 15]
            }
        },
        {
            // טופס הפקה: the questionnaire template (sections, questions, texts, auto-lock)
            path: '/settings/production-form',
            name: 'productionFormSettings',
            component: () => import('@/components/Settings/ProductionFormSettings.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view',
                requireService: 17
            }
        },
        {
            // שעון נוכחות: the regular day, the overtime split, the automatic break, the forgotten-shift limit
            path: '/settings/time-clock',
            name: 'timeClockSettings',
            component: () => import('@/components/Settings/TimeClockSettings.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            // לוח תשלומים: the schedule templates, auto-spread on signing, the whatsapp reminder
            path: '/settings/payment-schedule',
            name: 'paymentScheduleSettings',
            component: () => import('@/components/Settings/PaymentScheduleSettings.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },
        {
            // לידים במייל: the lead mailboxes, the mail that arrived, the field marking
            path: '/email-leads',
            name: 'emailLeads',
            component: () => import('@/components/EmailLeads/EmailLeadsPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view',
                requireService: 16
            }
        },
        {
            path: '/booking-requests',
            name: 'bookingRequests',
            component: () => import('@/components/Booking/BookingRequestsPage.vue'),
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'calendar.view',
                requireService: 10
            }
        },

        {
            path: '/settings/:tab',
            name: 'settingsTabSelected',
            component: Settings,
            meta: {
                requiresAuth: true,
                userInRole: [Role.Resseler, Role.HallManager],
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },

        {
            path: '/food-menu',
            name: 'foodMenu',
            component: () => import('@/pages/FoodMenuPage'),
            props: { kind: 'food' },
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view'
            }
        },

        {
            // תפריט בר: the food menu page over the bar menu - its own module (biz-service 19)
            path: '/bar-menu',
            name: 'barMenu',
            component: () => import('@/pages/FoodMenuPage'),
            props: { kind: 'bar' },
            meta: {
                requiresAuth: true,
                matchHeight: true,
                havePermission: 'settings.view',
                requireService: 19
            }
        },



        {
            path: '/browse/:entity',
            name: 'BrowsePage',
            component: BrowsePage,
            meta: {
                requiresAuth: true,
                //userInRole: [1, 2, 5],
                matchHeight: true
            }
        },


        {
            path: '/events/:eventID/build',
            name: 'event-builder-page',
            component: EventBuilderPage,
            meta: {
                requiresAuth: true,
                havePermission: 'event_planner.create'
            }
        },

        {
            path: '/tables/:eventID',
            name: 'tables',
            component: TablesStatus,
            meta: {
                requiresAuth: true,
                minimumUserLevel: 3,
                matchHeight: true
            }
        },

        {
            path: '/arrival/:eventID',
            name: 'arrival',
            component: () => import('@/components/Guests/GuestsArrival'),
            meta: {
                requiresAuth: true,
                havePermission: 'guests.arrival',
                matchHeight: true
            }
        },
        {
            path: '/messages',
            name: 'messages',
            component: () => import('@/components/PlanupMultiMessages/PlanupMultiMessagesPage'),
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/messageTemplates',
            name: 'MessageTemplates',
            component: () => import('@/components/MessageTemplates/MessageTemplatesPage'),
            meta: {
                requiresAuth: true,
                havePermission: 'settings.view'
            }
        },
        {
            path: '/sms',
            name: 'sms',
            component: SMS,
            meta: {
                requiresAuth: true,
                minimumUserLevel: 3,
                matchHeight: true
            }
        },

        {
            path: '/seating/:eventID',
            name: 'seating',
            component: Seating,
            meta: {
                requiresAuth: true,
                //userInRole: [Role.Admin, Role.Resseler, Role.HallManager, Role.HallManagerChild],
                matchHeight: true
            }
        },

        {
            path: '/screen',
            name: 'screen',
            component: () => import('@/components/Screen/Screen'),
            meta: {
                requiresAuth: true,
                userInRole: [Role.Admin, Role.Resseler],
                matchHeight: true
            }
        },


        {
            path: '/screen/:eventID',
            name: 'screenEvent',
            component: () => import('@/components/Screen/Screen'),
            meta: {
                requiresAuth: true,
                minimumUserLevel: 3,
                matchHeight: true
            }
        },
        {
            path: '/pdf/obligation',
            name: 'pdfObligation',
            props: true,
            component: () => import('@/components/Pdf/pdfObligation'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pdf/contract',
            name: 'pdfContract',
            props: true,
            component: () => import('@/components/Pdf/pdfContract'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pdf/quote',
            name: 'pdfQuotation',
            props: true,
            component: () => import('@/components/Pdf/pdfQuotation'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pdf/:type',
            name: 'pdfPage',
            props: true,
            component: () => import('@/pages/pdfExportPage'),
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/contract-sign/:quoteId',
            name: 'SignContractPage',
            props: true,
            component: SignContractPage,
            meta: {
                requiresAuth: false,
            }
        },
        {
            path: '/quotation/:id',
            name: 'QuotationForm',
            component: QuotationForm,
            meta: {
                requiresAuth: true,

            }
        },


        {
            path: '/meeting/add/:customerId',
            name: 'AddMeeting',
            component: MeetingForm,
            meta: { requiresAuth: true }
        },

        {
            path: '/meeting/:id',
            name: 'MeetingForm',
            component: MeetingForm,
            meta: { requiresAuth: true, havePermission: 'meeting.create' }
        },
        {
            path: '/meeting/:id/view',
            name: 'MeetingView',
            component: MeetingView,
            meta: { requiresAuth: true }
        },
        {
            path: '/events/:event/drinks',
            name: 'DrinksAssign',
            component: DrinksAssign,
            meta: { requiresAuth: true, }
        },

        {
            path: '/waiters',
            name: 'waiters',
            component: () => import('@/pages/WaitersPage'),
            meta: { requiresAuth: true }
        },
        {
            path: '/events/:event/waiters',
            name: 'WaiterTableAssign',
            component: () => import('@/components/Waiters/WaiterTableAssign'),
            meta: { requiresAuth: true }
        },

        {
            path: '/waiters/shifts',
            name: 'WaiterShiftAssign',
            component: () => import('@/components/Waiters/WaiterShiftAssign'),
            meta: { requiresAuth: true }
        },


        // this was doubled

        // {
        //     path: '/events/:event/drinks',
        //     name: 'DrinksAssign',
        //     component: DrinksAssign,
        //     meta: { requiresAuth: true, }
        // },

        {
            path: '/billing',
            name: 'billing',
            component: () => import('@/pages/BillingPage'),
            meta: { requiresAuth: true, havePermission: 'billing', }
        },
        {
            path: '/billing/:event',
            name: 'billing of event',
            component: () => import('@/components/Billing/EventBilling'),
            meta: { requiresAuth: true, havePermission: 'billing', }
        },
        {
            path: '/analytics',
            name: 'AnalyticsPage',
            component: AnalyticsPage,
            meta: { requiresAuth: true, minimumUserLevel: 5, }
        },
        {
            path: '/catalog',
            name: 'CatalogPage',
            component: () => import('@/components/Catalog/CatalogPage'),
            meta: { requiresAuth: true }
        },
        {
            path: '/documents',
            name: 'documents',
            component: () => import('@/components/Documents/DocumentsPage.vue'),
            meta: { requiresAuth: true, havePermission: 'settings.view' }
        },
        {
            path: '/parameters',
            name: 'ParametersPage',
            component: () => import('@/components/ParametersPage/ParametersPage'),
            meta: { requiresAuth: true, havePermission: 'settings.view' }
        },
        {
            path: '/processes',
            name: 'ProcessesPage',
            component: () => import('@/components/ProcessesPage/ProcessesPage'),
        },
        {
            path: '/templates',
            name: 'TemplatesPage',
            component: () => import('@/components/TemplatesPage/TemplatesPage'),
        },
        {
            path: '/itemgroups',
            name: 'ItemGroupsPage',
            component: () => import('@/components/ItemGroups/ItemGroups.vue'),
            meta: { requiresAuth: true, havePermission: 'settings.view' }
        },
        {
            path: '/heshboniot-israel',
            name: 'HeshboniotIsraelPage',
            component: () => import('@/pages/HeshboniotIsraelPage.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/notifications',
            name: 'NotificationsPage',
            component: () => import('@/components/Notifications/NotificationsPage.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/custom-fields',
            name: 'CustomFieldsAdmin',
            component: () => import('@/components/CustomFields/CustomFieldsAdmin.vue'),
            meta: { requiresAuth: true, havePermission: 'settings.view' }
        }


    ]
})

export default router

// releases any leftover scroll lock (body overflow:hidden + backdrops) after every
// URL change - see modules/ScrollLockGuard.js
installScrollLockGuard(router);

// the tab's title is the bare server name again after every URL change. A page that names what
// it edits (עריכת משתמש / עריכת אירוע set "DevUp :: <name>") used to leave that name on every
// page visited after it - the root admin inside an account, having opened a user's edit page,
// read "DevUp :: צחי" on /tasks as "I am logged in as צחי" (2026-10-07).
router.afterEach(() => {
    document.title = getPageTitle();
});


///////////////////////////////////////////////////////////////////////////////////
//
// Dead menu links after a deploy.
//
// Every page in the side menu is a lazy route (component: () => import(...)), so
// clicking one fetches a webpack chunk before the URL changes. The built chunks are
// content-hashed and `planup` option 1 replaces the whole dist, so the moment a new
// build goes up, the chunk names in an ALREADY-OPEN tab stop existing on the server.
// That tab's next click on any page it hasn't visited yet fetches a 404, import()
// rejects, and vue-router aborts the navigation - silently. No error, no toast, the
// URL doesn't move: the link just does nothing. webpack caches the rejected chunk
// promise too, so it keeps doing nothing for the rest of the session, while the
// pages already loaded carry on working - which is why it reads as "SOMETIMES the
// menu links don't work".
//
// A full page load onto the target fixes it: it fetches the current index.html,
// which names the chunks that actually exist. Guarded per target so a genuinely
// missing file costs one reload, not a loop.
//
///////////////////////////////////////////////////////////////////////////////////

// webpack 5 throws ChunkLoadError; webpack 4 / native dynamic import phrase it differently.
const CHUNK_LOAD_FAILURE = /Loading (CSS )?chunk .* failed|ChunkLoadError|dynamically imported module/i;

let navigationTarget = null;

router.beforeEach((to, from, next) => {
    navigationTarget = to.fullPath;
    next();
});

router.onError(error => {

    const message = (error && (error.message || String(error))) || '';

    if (!(error && error.name == 'ChunkLoadError') && !CHUNK_LOAD_FAILURE.test(message))
        return;

    const target = navigationTarget || window.location.pathname;

    //one reload per target per tab - if the file is really gone from the server the
    //reload won't help, and looping on it is worse than the dead link.
    try {
        if (sessionStorage.getItem('chunkReloadedFor') == target) return;
        sessionStorage.setItem('chunkReloadedFor', target);
    } catch (e) {
        //private mode / storage disabled: still worth the one reload
    }

    console.log('route chunk failed to load, reloading onto', target, '-', message);

    window.location.assign(target);
});

//everything a logged-in session needs running in the background: whatsapp status + its poll,
//the socket (whatsapp/email/notification push), and the localhost notification-poll fallback.
//Idempotent. Historically this lived only inside the requiresAuth branch of beforeEach, so a
//session that ENTERED through the landing page (its branch dispatches getDashboardData itself
//and only redirects) got NO status poll and NO socket for its whole lifetime — whatsapp could
//die and nothing in the UI would ever notice. Both branches call this now.
function initLoggedInSessionServices() {

    //yonso get whatsapp status
    planup.$handlers.whatsappHandler.getStatus();

    //poll status so a one-off reconnect blip at load time doesn't leave the
    //"Whatsapp מנותק" warning stuck for the whole session (it now self-corrects).
    //20s so the 3-miss debounce confirms a real disconnect within ~a minute.
    if (!window.planup.__whatsappStatusPoll) {
        window.planup.__whatsappStatusPoll = setInterval(() => {
            planup.$handlers.whatsappHandler.getStatus();
        }, 20000);
    }

    //yonso connect socket securely

    if (!window.planup.$socket && !window.location.host.includes('localhost')) {

        window.planup.$socket = io.connect(Config.SETTINGS.SOCKET_URL, { query: `access_token=${planup.$store.state.access_token}` });

        // ── Activity notifications (build spec §5.2) ──
        window.planup.$socket.on('notification', note => {
            if (!note) return;
            store.commit('pushNotification', note);
            if (window.planup && window.planup.$notify) {
                window.planup.$notify({ type: 'info', title: note.text || 'התראה חדשה' });
            }
        });

        window.planup.$socket.on('message', messageData => {

            console.log('yonso got socket message:', messageData);

            switch (messageData.msgType) {

                case 'message':
                    planup.$handlers.whatsappHandler.handleIncomingMessage(messageData);
                    break;

                //a customer replied to a mail the system sent - smtpServer.ts relays it here
                case 'email':
                    planup.$handlers.emailHandler.handleIncomingEmail(messageData);
                    break;

                case 'connected':
                    planup.$handlers.whatsappHandler.handleConnected(messageData);
                    break;

                //baileys announces a definitive loggedOut (device unlinked) — until now
                //this message was silently dropped and browsers waited on the poll debounce
                case 'disconnected':
                    planup.$handlers.whatsappHandler.handleDisconnected(messageData);
                    break;

                case 'ack':
                    planup.$handlers.whatsappHandler.handleAck(messageData);
                    break;

                //a message in the support thread (support answered, or the business wrote to the
                //support number from its phone) - SupportModal keeps the thread and the badge
                case 'supportMessage':
                    planup.$root.$emit('supportMessageArrived', messageData);
                    break;

                //the root admin just sent an announcement to this account - AnnouncementPopup asks
                //announcements/pending (the server decides who of the account gets it)
                case 'announcement':
                    planup.$root.$emit('announcementsChanged', messageData);
                    break;

                //עמדת אירוח: an arrival was marked / a guest added / a list imported on some
                //device — the station tabs and the customer page's live tab patch themselves
                case 'hostingStation':
                    planup.$root.$emit('hostingStationUpdate', messageData);
                    break;

                //לידים במייל: a mail reached one of the lead mailboxes (the sample the user is
                //waiting for, a lead that was opened, one that could not be read) — the page follows
                case 'emailLead':
                    planup.$root.$emit('emailLeadUpdate', messageData);
                    break;
            }

        });

    } else if (!window.planup.$socket) {

        console.log('Socket is off on localhost to keep network tab clean');

        //notification poll fallback where the socket is off
        if (!window.planup.__notificationPoll) {
            store.dispatch('pollNotifications');
            window.planup.__notificationPoll = setInterval(() => {
                store.dispatch('pollNotifications');
            }, 30000);
        }

    }

}


//apply middleware between routes
router.beforeEach((to, from, next) => {





    // debugger;




    //lets quick kill any open bootstrap modal backgrounds
    //this is necessary if for example we go back one page when a modal was open.
    //the matching afterEach pass (installScrollLockGuard) is the one that unlocks
    //scrolling - it has to wait until the old page, and its modal, are gone.
    releaseScrollLocks();




    $("html, body").animate({ scrollTop: 0 }, "fast");

    //save from to var (history backup)
    window.routerLastFrom = from.name;



    if (store.state.isLogged && to.name != 'login') {
        setTimeout(function () { $(".wrapper").fadeIn() }, 500); //prevent login to app "view jump"
    }

    // Redirect logged-in users from landing page to dashboard
    if (store.state.isLogged && to.name == 'landing') {
        next(homeRouteFor(store.state.user));
        return;
    }

    // עמדת אירוח: the reception-desk login has exactly one place in the app. Everything else
    // (a typed URL, a stale bookmark) lands back on the station.
    if (store.state.isLogged && isHostingStationUser(store.state.user) && to.name != 'login' && !String(to.path || '').startsWith('/hosting-station')) {
        next('/hosting-station');
        return;
    }

    // If navigating to landing page with a token cookie, check auth and redirect to dashboard
    if (to.name == 'landing' && !store.state.dashboardInitiated && getTokenCookie()) {
        store.dispatch('checkLogin');
        store.dispatch('getDashboardData')
            .then(() => {
                //sessions that enter here skip the requiresAuth branch below (dashboardInitiated
                //is already true by then) — start the background services here too
                initLoggedInSessionServices();
                next(homeRouteFor(store.state.user));
            })
            .catch(() => {
                // Not logged in or token invalid, stay on landing page
                next();
            });
        return;
    }

    store.state.usedBanners = [];

    //yonso added some hax here with to.name!='login'
    // if (to.meta.requiresAuth && !store.getters.isLogged && to.name!='login') {
    //     next({
    //         path: '/login',
    //         query: {
    //             redirect: to.fullPath,
    //         },
    //     });

    //     return; //yonso added return here, cuz otherwise this will happen twice
    // }





    //yonso changed this: now our dashboard-data is our is-logged
    if (!store.state.dashboardInitiated && to.name != 'login' && to.meta.requiresAuth) {
        // if (!store.state.dashboardInitiated && to.meta.requiresAuth && store.getters.isLogged) {


        //yonso add this from is-logged
        store.dispatch('checkLogin');

        store.dispatch('getDashboardData')
            .then(response => {


                //whatsapp status + poll, socket, notifications — shared with the landing branch
                initLoggedInSessionServices();


                //yonso add
                store.getters.isLogged - true;

                // document.body.className = (store.state.preferences.menuState == 'open' ? 'menu_open' : '');


                //yonso removes this
                // if (to.name == 'login' && store.getters.dashboardInitiated && store.getters.isLogged) {
                //     if (to.query.redirect != '') {
                //         next(to.query.redirect);
                //     } else {
                //         next('/');
                //     }
                // }

                if (!to.matched.length) {
                    next('/notFound');
                } else {

                    if (to.matched.some(record => record.meta.requiresAuth)) {
                        if (!store.getters.isLogged) {
                            next({
                                path: '/login',
                                query: {
                                    redirect: to.fullPath,
                                },
                            });
                        } else {
                            if (isHostingStationUser(store.state.user)) {
                                // the reception desk never sees the welcome / settings bounce
                                if (String(to.path || '').startsWith('/hosting-station')) next(); else next('/hosting-station');
                            } else if (store.state.user.type != 1 && !store.state.businessSettings.hetPey && !store.state.businessSettings.stopDisplayingWelcomePopup) {
                                next({
                                    path: '/settings'
                                })
                            } else {
                                next();

                            }
                        }
                    } else {



                        next();



                    }
                }
            }).catch(



                error => {

                    // debugger;

                    console.log('Error in index.js');

                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath,
                        },
                    });
                }
            )

    } else {
        if (to.name == 'login' && store.getters.dashboardInitiated && store.getters.isLogged) {

            if (to.query.redirect != '') {
                next(to.query.redirect);
            } else {
                next(homeRouteFor(store.state.user));
            }
        } else {
            if (!to.matched.length) {
                next('/notFound');
            } else {

                if (to.matched.some(record => record.meta.requiresAuth)) {
                    if (!store.getters.isLogged) {
                        next({
                            path: '/login',
                            query: {
                                redirect: to.fullPath,
                            },
                        });
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            }
        }
        next();

    }

    if ((!store.state.isLogged || to.name == 'login' || to.name == 'passwordRecovery') && to.name != 'notFound') {
        // document.body.className = 'loginWrap';

    } else {
        // document.body.className = (store.state.preferences.menuState == 'open' ? 'menu_open' : '');
    }

    // if (to.meta.matchHeight) {
    //     setTimeout(function () {
    //         window.addEventListener('DOMContentLoaded', (event) => {
    //             $(".matchHeight").matchHeight();
    //         });

    //     }, 300)
    // }

    setTimeout(function () {
        const user = store.state.user

        // remove this line !!!! only for demo
        //if(user.type == Role.HallManager) return

        if (!guardInRole(to, store.state.user)) {
            console.log('role guard: access denied, redirecting to homepage', to.path, to.meta.userInRole, store.state.user.type)
            next('/dashboard');
        }

        if (typeof to.meta.havePermission !== 'undefined' && to.meta.havePermission != '') {

            if (user.permissions == null) {
                store.dispatch('getLoggedUserInfo').then(user => {
                    store.state.user = user
                    if (!guardHavePermission(to, user)) {
                        console.log('havePermission guard: access denied, redirecting to homepage', to.meta.havePermission, store.state.user.type)
                        next('/dashboard');
                    }
                })
            } else {
                if (!guardHavePermission(to, user)) {
                    console.log('havePermission guard: access denied, redirecting to homepage', to.meta.havePermission, user.permissions)
                    next('/dashboard');
                }
            }

        }

        if (!guardRoleLevel(to, user)) {
            console.log('role-level guard: access denied, redirecting to homepage, route:', to, user)
            next('/dashboard');
        }

        // Account-level service gate (system admin enables per account via biz-services):
        // routes carrying meta.requireService are reachable only when the user's account has
        // that service id in users.bizServices.
        // (the reception-desk login exists only while service 11 is on, and its API refuses
        // otherwise — its own row's list is not what gates it)
        if (typeof to.meta.requireService !== 'undefined' && user && !isHostingStationUser(user)) {
            const services = (user.bizServices || []).map(String);
            if (![].concat(to.meta.requireService).some(id => services.includes(String(id)))) {
                console.log('service guard: access denied, redirecting to homepage', to.meta.requireService, user.bizServices)
                next('/dashboard');
            }
        }

    }, 2500);

    // if (store.state.isKiosk) document.body.className = ''

})
